import * as type from "../types";

export function getObjectionsOrderMatchRequested(organizationId) {
  return {
    type: type.GET_OBJECTIONS_ORDER_MATCH_REQUESTED,
    payload: organizationId,
  };
}
export function getObjectionsOrderMatchSucceeded(data) {
  return {
    type: type.GET_OBJECTIONS_ORDER_MATCH_SUCCEEDED,
    payload: data,
  };
}
export function getObjectionsOrderMatchFailed() {
  return {
    type: type.GET_OBJECTIONS_ORDER_MATCH_FAILED,
  };
}
export function getObjectionsRequested(filter) {
  return {
    type: type.GET_OBJECTIONS_REQUESTED,
    payload: filter,
  };
}
export function getObjectionsSucceeded(data) {
  return {
    type: type.GET_OBJECTIONS_SUCCEEDED,
    payload: data,
  };
}
export function getObjectionsFailed() {
  return {
    type: type.GET_OBJECTIONS_FAILED,
  };
}
export function getObjectionsHistoryRequested(filter) {
  return {
    type: type.GET_OBJECTIONS_HISTORY_REQUESTED,
    payload: filter,
  };
}
export function getObjectionsHistorySucceeded(data) {
  return {
    type: type.GET_OBJECTIONS_HISTORY_SUCCEEDED,
    payload: data,
  };
}
export function getObjectionsHistoryFailed() {
  return {
    type: type.GET_OBJECTIONS_HISTORY_FAILED,
  };
}
export function setObjectionsFilter(data) {
  return {
    type: type.SET_OBJECTIONS_FILTER,
    payload: data,
  };
}
export function setObjectionsFilterOrganization(data) {
  return {
    type: type.SET_OBJECTIONS_FILTER_ORGANIZATION,
    payload: data,
  };
}
export function setObjectionsHistoryFilter(data) {
  return {
    type: type.SET_OBJECTIONS_HISTORY_FILTER,
    payload: data,
  };
}
export function setObjectionsHistoryFilterOrganization(data) {
  return {
    type: type.SET_OBJECTIONS_HISTORY_FILTER_ORGANIZATION,
    payload: data,
  };
}
